import { render, staticRenderFns } from "./ViewAllNotifications.vue?vue&type=template&id=57792714&scoped=true"
import script from "./ViewAllNotifications.vue?vue&type=script&lang=js"
export * from "./ViewAllNotifications.vue?vue&type=script&lang=js"
import style0 from "./ViewAllNotifications.vue?vue&type=style&index=0&id=57792714&prod&lang=scss&scoped=true"
import style1 from "./ViewAllNotifications.vue?vue&type=style&index=1&id=57792714&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57792714",
  null
  
)

export default component.exports